// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__18Oah","inputWrap":"CustomTip_inputWrap__12MIP"};